import {
  GET_POI_PREFERENCE,
  GET_MIXED_POI_BY_CITY,
  GET_POI_FROM_FAVORITE,
  GET_POI,
  GET_POI_NEW,
  GET_POI_COMMENTS
} from '../actionTypes';
import {
  PENDING,
  SUCCESS,
  FAILURE,
  END
} from '../../utils/status';
import * as poiService from '../../services/poi';
import {select as selectMixedPois} from '../reducers/poi/mixedPois';
import {select as selectPoiComments} from '../reducers/poi/poiComments';



/**
 * 获取行程偏好设置列表
 * @param {*} tcm_id 
 * @param {*} trip_id 
 */
export function getPoiPreference(tcm_id, trip_id) {
  return function (dispatch) {
    dispatch({
      type: GET_POI_PREFERENCE,
      status: PENDING
    });

    return poiService.getPreference(tcm_id, trip_id)
      .then(function (data) {
        let status = data.length === 0 ? END : SUCCESS;

        dispatch({
          type: GET_POI_PREFERENCE,
          status: status,
          data: data
        });
      
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_POI_PREFERENCE,
          status: FAILURE,
          data: err
        });

        return err;
      });
  };
}




/**
 * 获取某个城市某个poi类别下的列表 
 * 选择旅行地页面
 * @param {*} trip_id 
 * @param {*} city_id 
 * @param {*} type 
 * @param {*} next_page 
 */

// 已被取消的 Promise 对象
let invalidPromise = Promise.resolve(true);
invalidPromise.cancel();
export function getPoisByCityMixed(trip_id, city_id, type, next_page) {
  return function (dispatch, getState) {
    let state = getState();
    let status = selectMixedPois(state, 'status');
    
    // 正在加载更多，或已经没有了，就不要挤了
    if (next_page !== '') {
      if (status === END || status === PENDING) {
        return invalidPromise;
      }
    }

    // 请求第一页，取消上一次请求
    if (getPoisByCityMixed.promise) {
      getPoisByCityMixed.promise.cancel();
      getPoisByCityMixed.promise = null;
      // 理论上还应该
      // dispatch(CANCEL)
    }
    dispatch({
      type: GET_MIXED_POI_BY_CITY,
      status: PENDING,
      poiType: type,
      cityId: city_id,
      nextPage: next_page
    });

    getPoisByCityMixed.promise = poiService.getPoisMixedByMiddleware(trip_id, city_id, type, next_page)
      .then(function (data) {
        let status = data.next_page === '' ? END : SUCCESS;

        dispatch({
          type: GET_MIXED_POI_BY_CITY,
          status: status,
          poiType: type,
          cityId: city_id,
          data: data,
          nextPage: data.next_page
        });
      
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_MIXED_POI_BY_CITY,
          status: FAILURE,
          poiType: type,
          cityId: city_id,
          data: err
        });

        return err;
      });
    
    return getPoisByCityMixed.promise;
  };
}

/**
 * 从收藏夹获取poi列表
 * 此处不需要分页
 * @param {*} city_id 
 */
export function getPoisByFavorite(city_id) {
  return function (dispatch) {
    dispatch({
      type: GET_POI_FROM_FAVORITE,
      status: PENDING
    });

    return poiService.getPoisFromFavorite(city_id)
      .then(function (data) {
        let status = data.length === 0 ? END : SUCCESS;

        dispatch({
          type: GET_POI_FROM_FAVORITE,
          status: status,
          data: data
        });
      
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_POI_FROM_FAVORITE,
          status: FAILURE,
          data: err
        });

        return err;
      });
  };
}


/**
 * 通过poi_uids 获取一个poi详情
 * @param {*} poi_uid 
 */
export function getOne(poi_uid) {
  return function (dispatch) {
    dispatch({
      type: GET_POI,
      status: PENDING
    });

    return poiService.getOne(poi_uid)
      .then(function (data) {
        let status = data.length === 0 ? END : SUCCESS;

        dispatch({
          type: GET_POI,
          status: status,
          data: data
        });
      
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_POI,
          status: FAILURE,
          data: err
        });

        return err;
      });
  };
}






/**
 * 1.2版本的
 * 通过poi_uid获取一个poi详情
 * @param {*} poi_uid 
 */
export function getOneNew(poi_uid) {
  return function (dispatch) {
    dispatch({
      type: GET_POI_NEW,
      status: PENDING
    });

    return poiService.getPoiDetailAndStation(poi_uid)
      .then(function (data) {
        let status = data.length === 0 ? END : SUCCESS;

        dispatch({
          type: GET_POI_NEW,
          status: status,
          data: data
        });
      
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_POI_NEW,
          status: FAILURE,
          data: err
        });

        return err;
      });
  };
}




/**
 * 1.2 版本 
 * 获取一个poi的评论列表
 * @param {*} poi_uid 
 * @param {*} type 
 * @param {*} next_page 
 */
let _CommentCache = {};
export function getPoiComments(poi_uid, type, next_page) {
  return function (dispatch, getState) {
    let state = getState();
    let status = selectPoiComments(state, 'status');
    
    // 正在加载更多，或已经没有了，就不要挤了
    if (next_page !== 1) {
      if (status === END || status === PENDING) {
        return invalidPromise;
      }
    }

    // 请求第一页，取消上一次请求
    if (getPoiComments.promise) {
      getPoiComments.promise.cancel();
      getPoiComments.promise = null;
      // 理论上还应该
      // dispatch(CANCEL)
    }
    dispatch({
      type: GET_POI_COMMENTS,
      status: PENDING,
      commentType: type,
      poi_uid: poi_uid,
      nextPage: next_page
    });

    //缓存评论列表
    let key = `${poi_uid}-${type}-${next_page}`;
    if(_CommentCache[key]){
      let data = _CommentCache[key];
      let status = data.next_page === '' ? END : SUCCESS;
      dispatch({
        type: GET_POI_COMMENTS,
        status: status,
        commentType: type,
        poiUid: poi_uid,
        data: data,
        nextPage: next_page
      });
      return data;
    }

    getPoiComments.promise = poiService.getPoiComments(poi_uid, type, next_page)
      .then(function (data) {
        let status = data.next_page === '' ? END : SUCCESS;
     
        if(!_CommentCache[key]){
          _CommentCache[key] = data;
        }
      
        dispatch({
          type: GET_POI_COMMENTS,
          status: status,
          commentType: type,
          poiUid: poi_uid,
          data: data,
          nextPage: next_page
        });
      
        return data;
      })
      .catch(function (err) {
        dispatch({
          type: GET_POI_COMMENTS,
          status: FAILURE,
          commentType: type,
          poiUid: poi_uid,
          data: err
        });

        return err;
      });
    
    return getPoiComments.promise;
  };
}









// WEBPACK FOOTER //
// ./src/store/actions/poi.js